//pdc-lb-

const libraryStyle = {
    uploadAttrContainer: 'pdc-lb-upload-attr-container',
    dropzone: 'pdc-lb-dropzone',
    dropzoneContainer: 'pdc-lb-dropzoneContainer',
    dropzoneContent: 'pdc-lb-dropzoneContent',
    dropzoneMessage: 'pdc-lb-dropzone-message',
    dropAreaActionsContainer: 'pdc-lb-droparea-actions-container',
    dropzoneBrowse: 'pdc-lb-dropzone-browse',

    homeMostUsedFile: 'pdc-lb-homeMostUsedFile',
    homeMostUsedFileField: 'pdc-lb-homeMostUsedFileField',
    noMarginColumn: 'pdc-lb-noMarginColumn',
};

export { libraryStyle };